export class FileUploader {
  folder: string | null = null;
  file: any = {};
}

export class FilesUploader {
  folder: string | null = null;
  files: any[] = [];
}
